/**
 * General theme object
 * @author Pablo Vidal
 */
Highcharts.theme = {};